<template>
    <vx-dropdown ref="dropdown" vs-custom-content :vs-trigger-click="triggerClick">
        <template v-slot="{ visible }">
            <slot :visible="visible" :value="localValue">
                <vx-action-icon
                    icon="CalendarIcon"
                    :hover-icon="visible ? 'XIcon' : 'CalendarIcon'"
                    :hover-color="visible ? 'danger' : 'primary'"
                    active-color="primary"
                    :active="!!value"
                    @click="tryClear($event, visible)"
                />
            </slot>
            <vs-dropdown-menu class="dropdown-menu">
                <slot name="top"></slot>
                <div class="flex justify-between">
                    <slot name="left"> </slot>

                    <v-date-picker
                        ref="calendar"
                        v-model="localValue"
                        :attributes="attributes_x"
                        :disabled-dates="disabledDates"
                        :available-dates="availableDates"
                        :is-dark="isThemeDark"
                    />
                    <slot name="right"></slot>
                </div>
                <slot name="bottom"></slot>
            </vs-dropdown-menu>
        </template>
    </vx-dropdown>
</template>

<script>
import { mapGetters } from 'vuex'
import VDatePicker from 'v-calendar/lib/components/date-picker.umd'

export default {
    name: 'vx-date-dropdown',
    components: {
        VDatePicker
    },
    props: {
        value: {
            type: [Date, String]
        },
        attributes: {
            type: Array,
            default: () => []
        },
        disabledDates: {
            type: [Object, Array]
        },
        availableDates: {
            type: [Object, Array]
        },
        closeOnSelect: {
            type: Boolean
        },
        triggerClick: {
            type: Boolean
        }
    },
    watch: {
        localValue(newV) {
            if (!newV || !this.$refs.calendar) {
                return
            }
            this.$refs.calendar.move(newV)
        }
    },
    data() {
        return {
            now: new Date().getStartOfDay()
        }
    },
    computed: {
        ...mapGetters({
            isThemeDark: 'user/isThemeDark'
        }),
        localValue: {
            get() {
                if (!this.value) {
                    return null
                }

                return new Date(this.value)
            },
            set(val) {
                this.$emit('input', val)

                if (!this.closeOnSelect) {
                    return
                }
                setTimeout(
                    function () {
                        this.$refs.dropdown.triggerClose()
                    }.bind(this),
                    50
                )
            }
        },
        attributes_x() {
            return [
                ...this.attributes,
                {
                    key: 'today',
                    bar: 'red',
                    dates: this.now
                }
            ]
        },
        dateString() {
            if (!this.localValue) {
                return 'No Date Set'
            }
            return this.formatUTCDateToDate(this.localValue)
        }
    },
    methods: {
        formatUTCDateToDate(value) {
            if (!value) {
                return ''
            }
            return new Date(value).toLocaleDateString('en-AU').slice(0, 10)
        },
        tryClear(e, visible) {
            if (!visible) {
                return
            }
            e.preventDefault()
            e.stopPropagation()
            this.localValue = null
        }
    }
}
</script>

<style lang="scss" scoped>
.dropdown-menu {
    ::v-deep .vc-container {
        background-color: transparent;
        border: none !important;
    }
}
</style>
